<template>
	<div :class="`${full ? 'grow' : ''} input-like flex items-center gap-2 cursor-pointer select-none`" @click.stop="update">
		<i v-if="checked" class="fa-solid fa-toggle-on text-green-600"/>
		<i v-else class="fa-solid fa-toggle-off text-red-600"/>
		<span v-if="label" class="grow whitespace-normal">{{ trans(label) }}</span>
		<span v-else-if="checked">{{ trans('general.enabled') }}</span>
		<span v-else>{{ trans('general.disabled') }}</span>
		<slot name="comment"/>
	</div>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {defineEmits, defineProps, ref, type Ref} from 'vue'

const props = defineProps<{
	modelValue:number|boolean,
	label?:string,
	full?:boolean,
	disabled?:boolean,
}>()

const emit = defineEmits([
	'update:modelValue',
])

const full:Ref<boolean> = ref(props.full)
const disabled:Ref<boolean> = ref(props.disabled)
const checked:Ref<number|boolean> = ref(props.modelValue)

function update():void{
	if(!disabled.value){
		checked.value = ((checked.value ? 1 : 0) + 1) % 2
		emit('update:modelValue', checked.value)
	}
}
</script>